"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ReviewTemplate () {
        return ReviewTemplate;
    },
    get ReviewTemplateWithNames () {
        return ReviewTemplateWithNames;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _formassignment = require("../form-assignment");
const ReviewTemplate = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    companyId: _utilsisomorphic.transformObjectId,
    formAssignments: _zod.z.array(_formassignment.TemplateFormAssignment),
    name: _models.ReviewTemplateModel.shape.name,
    createdAt: _models.ReviewTemplateModel.shape.created_at,
    createdBy: _models.ReviewTemplateModel.shape.created_by.unwrap().optional(),
    updatedAt: _models.ReviewTemplateModel.shape.last_update,
    updatedBy: _models.ReviewTemplateModel.shape.updated_by,
    lastOpenedAt: _utilsisomorphic.transformDate.optional(),
    lastOpenedBy: _utilsisomorphic.transformObjectId.optional()
});
const ReviewTemplateWithNames = ReviewTemplate.extend({
    formAssignments: _zod.z.array(_formassignment.TemplateFormAssignmentWithNames)
});
